module.exports = __webpack_public_path__ + "static/media/Fornuis.a24f5af7.mp3";